<template>
  <vue-good-table
    :columns="columns"
    :rows="filteredGroups"
    :line-numbers="true"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'namegroup'">
        <span>{{ props.row.name }}</span>
      </span>
      <span v-if="props.column.field == 'typename'">
        <span>{{ typeName(props.row.type) }}</span>
      </span>
      <span v-if="props.column.field == 'action'">
        <b-button variant="primary" block size="sm" :to="{ name: 'settings.groups.show', params: { id: props.row.id } }">
          ดูข้อมูล
        </b-button>
      </span>
    </template>
    <div slot="emptystate" class="text-center text-muted py-2">
      ไม่มีข้อมูล
    </div>
  </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    groups: Array,
    searchTerm: { type: String, required: false, default: null }
  },
  data () {
    return {
      columns: [
        {
          label: 'ชื่อหน่วยงาน',
          field: 'namegroup'
        },
        {
          label: 'ประเภท',
          field: 'typename',
          width: '120px'
        },
        {
          label: 'การกระทำ',
          field: 'action',
          width: '95px'
        }
      ]
    }
  },
  computed: {
    filteredGroups () {
      if (this.searchTerm !== null) {
        return this.groups.filter((group) => group.name.includes(this.searchTerm))
      } else {
        return this.groups
      }
    }
  },
  methods: {
    typeName (value) {
      if (value === 'Club') {
        return 'ชมรม'
      } else if (value === 'Association') {
        return 'สโมสร'
      } else if (value === 'Group') {
        return 'ชุมนุม'
      } else if (value === 'StudentCouncil') {
        return 'สโมสรนักศึกษา'
      } else if (value === 'StudentUnion') {
        return 'องค์การนักศึกษา'
      } else if (value === 'PeopleGroup') {
        return 'กลุ่ม'
      } else if (value === 'Council') {
        return 'สภา'
      }
    },
    searchGroup (row, col, cellValue, searchTerm) {
      return this.groups.filter((group) => group.name.includes(searchTerm))
    }
  }
}
</script>

<style>

</style>
